// 카카오맵 JS SDK 온디맨드 동적 로드 (싱글톤 Promise)
// 국내 지도 픽커를 열 때만 로드된다. autoload=false + kakao.maps.load 로 초기화 안정화.

const KAKAO_APP_KEY = "56791d35eb7479b8ba1e50edc22372e4";
let _promise = null;

export const loadKakaoSdk = () => {
    if (_promise) return _promise;

    _promise = new Promise((resolve, reject) => {
        if (window.kakao && window.kakao.maps && window.kakao.maps.Map) {
            resolve(window.kakao);
            return;
        }
        let script = document.createElement("script");
        script.src = "https://dapi.kakao.com/v2/maps/sdk.js?appkey=" + KAKAO_APP_KEY + "&autoload=false";
        script.async = true;
        script.onload = () => {
            if (window.kakao && window.kakao.maps) {
                window.kakao.maps.load(() => resolve(window.kakao));
            } else {
                reject(new Error("카카오맵 SDK 로드 실패"));
            }
        };
        script.onerror = () => reject(new Error("카카오맵 SDK 네트워크 오류"));
        document.head.appendChild(script);
    });
    return _promise;
};
